// extracted by css-extract-rspack-plugin
export default {"centeredDiv":"_975b061f"};